import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { VALIDATE_USER_WATCHER, SET_PASSWORD_WATCHER } from "./constants"
import {
  validateUserSuccess,
  validateUserFailed,
  setPasswordSuccess,
  setPasswordFailed,
} from "./actions"
import { LOCAL_TOKEN } from "../../utils/storage"

export function validateUserApi(params = {}) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}password/reset/valid`,
    params,
  })
}

export function* validateUserSaga(action) {
  try {
    const {
      data: { data },
    } = yield call(validateUserApi, action.payload)

    yield put(validateUserSuccess(data.code))
  } catch (error) {
    yield put(validateUserFailed(404))
  }
}

// SET
export function setPasswordApi(data = {}) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}password/reset`,
    data,
  })
}

export function* setPassSaga(action) {
  try {
    const data = yield call(setPasswordApi, action.payload)
    yield put(setPasswordSuccess())
  } catch (error) {
    returnMessage(error)
    yield put(setPasswordFailed())
  }
}

// Individual exports for testing
export default function* setPasswordSaga() {
  yield takeLatest(VALIDATE_USER_WATCHER, validateUserSaga)
  yield takeLatest(SET_PASSWORD_WATCHER, setPassSaga)
}
